"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("../styles");
const FiltersContainer_styles_1 = require("./FiltersContainer.styles");
const FiltersContainer = ({ headers, tableId, isLoading = false }) => {
    return (react_1.default.createElement(styles_1.StyledFiltersContainer, null, headers
        .filter((column) => column.canFilter &&
        column.Filter &&
        column.filterLocation === 'above')
        .sort((aCol, bCol) => (aCol.filterOrder || 0) - (bCol.filterOrder || 0))
        .map((column) => (react_1.default.createElement(FiltersContainer_styles_1.StyledFilterWrapper, { key: `filter-${column.id}` }, column.render('Filter', {
        tableId,
        showLabel: column.showFilterLabel != null ? column.showFilterLabel : true,
        isLoading
    }))))));
};
exports.default = FiltersContainer;
//# sourceMappingURL=FiltersContainer.js.map